<template>
  <Form/>
</template>

<script>
import Form from '@/views/team/Form'
export default {
  name: 'Create',
  components: { Form }
}
</script>
